import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import React, { useEffect, useRef } from 'react';
import { ChallengeCountdownTimer } from '@/components/custom/challenge';

export function WeekChallengeCountdownTimer(props) {
  let intervalRef = useRef();

  const { counter, setCounter, start } = useWeeklyChallenge();

  useEffect(() => {
    if (start) {
      intervalRef.current = setInterval(() => {
        if (counter > 0) setCounter(counter - 1);
      }, 1000);

      return () => clearInterval(intervalRef.current);
    }
  }, [counter, start]);

  return (
    <ChallengeCountdownTimer
      counter={counter}
      {...props}
    />
  );
}
